/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import Spinner from "Component/Spinner";
import { Link } from "react-router-dom";
import { fetchApi } from "Config/fetchApi";
import { Notify } from "Component/Notify";
import { handleError } from "Helper";

export default function ListCard() {
  const [datas, setDatas] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const getDatas = async () => {
    setIsLoading(true);
    try {
      const response = await fetchApi().get(`/dashboard/all-card-statistic`);
      setIsLoading(false);
      setDatas(response.data?.data[0]);
    } catch (err) {
      setDatas([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  useEffect(() => {
    getDatas();
  }, []);

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <Link
        to={"/management-data/watchlist"}
        className="bg-white text-center flex flex-col gap-2 items-center justify-center border-solid border-gray-300 border rounded-xl shadow-md"
      >
        <p className="text-7xl font-bold">
          {isLoading ? (
            <Spinner classAddition={"h-10"} />
          ) : (
            <>{datas?.totalDpo || 0}</>
          )}
        </p>
        <p>Total Daftar Pencarian Orang</p>
      </Link>
      <Link
        to={"/report/home"}
        className="bg-white text-center p-10 flex flex-col gap-2 items-center justify-center border-solid border-gray-300 border rounded-xl shadow-md"
      >
        <p className="text-7xl font-bold">
          {isLoading ? (
            <Spinner classAddition={"h-10"} />
          ) : (
            <>{datas?.totalFace + datas?.totalDpo || 0}</>
          )}
        </p>
        <p>Total Wajah Terdaftar</p>
      </Link>
      <Link
        to={"/management-data/streaming-device"}
        className="bg-white text-center p-10 flex flex-col gap-2 items-center justify-center border-solid border-gray-300 border rounded-xl shadow-md"
      >
        <p className="text-7xl font-bold">
          {isLoading ? (
            <Spinner classAddition={"h-10"} />
          ) : (
            <>{datas?.total_streaming_device || 0}</>
          )}
        </p>
        <p>Total Perangkat Streaming</p>
      </Link>
      <Link
        to={"/management-data/operation-police"}
        className="bg-white text-center p-10 flex flex-col gap-2 items-center justify-center border-solid border-gray-300 border rounded-xl shadow-md"
      >
        <p className="text-7xl font-bold">
          {isLoading ? (
            <Spinner classAddition={"h-10"} />
          ) : (
            <>{datas?.total_operation || 0}</>
          )}
        </p>
        <p>Total Operasi Berjalan</p>
      </Link>
    </div>
  );
}
